import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import nerdUII18n from "../i18n";
import { NerdConfirmContext } from "./nerdConfirmContext";
import { NerdConfirmDialog } from "./nerdConfirmDialog";
export const NerdConfirmContextProvider = NerdConfirmContext.Provider;
/**
 * NerdConfirm
 *
 *
 * @param {PropsWithChildren<unknown>} props Component props
 * @returns {ReactElement} NerdConfirm
 */
export default function NerdConfirmProvider(props) {
    const { t } = useTranslation("common", { i18n: nerdUII18n });
    const defaultOptions = {
        title: t("components:nerdConfirm.are_you_sure"),
        cancelButtonText: t("global.cancel"),
        confirmButtonText: t("components:nerdConfirm.confirm"),
        content: t("components:nerdConfirm.ask_confirmation"),
        cancelButtonProps: {
            color: "neutral",
            variant: "soft",
        },
        confirmButtonProps: {
            color: "primary",
        },
    };
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState({});
    const _setOpen = (options = {}) => {
        setOptions(options);
        setOpen(true);
    };
    const closeDialog = () => {
        setOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(NerdConfirmContextProvider, { value: { setOpen: _setOpen }, children: props.children }), _jsx(NerdConfirmDialog, { options: { ...defaultOptions, ...options }, open: open, closeDialog: closeDialog })] }));
}
